import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const categoryApi = createApi({
    reducerPath: "category",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ['category'],
    endpoints: (builder) => ({

        getAllCategories: builder.query({
            query: ({ page, limit, search }) => ({
                url: `admin/categories?page=${page + 1}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                total_length: res?.data?.data?.length > 0 ? res?.data?.total : 0,
                data: res.data?.data,
            }),
        }),

        getCategories: builder.query({
            query: ({ page, limit, search, status }) => ({
                url: `categories?page=${page + 1}&limit=${limit}&search=${search}&status=${status}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                total_length: res.data.categories.length > 0 ? res.data.meta.total_records : 0,
                total_active: res.data.categories.length > 0 ? res.data.meta.total_active : 0,
                total_inactive: res.data.categories.length > 0 ? res.data.meta.total_inactive : 0,
                filtered_count: res.data.categories.length > 0 ? res.data.meta.filtered_count : 0,

                data: res.data.categories,
            }),
            providesTags: ['category'],
        }),

        addCategory: builder.mutation({
            query: (data) => ({
                url: `categories`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ['category'],
        }),

        updateCategory: builder.mutation({
            query: ({ id, data }) => ({
                url: `categories/${id}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['category'],
        }),

        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `categories/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["category"],
        }),

        getSuggestionCategories: builder.query({
            query: ({ page, limit, search }) => ({
                url: `categories/name-suggestions?page=${page + 1}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (res) => ({
                data: res.data?.data,
            }),
        }),
        getAllProject: builder.query({
            query: ({ page, limit, search }) => {
                let url = `view-all-projects`;

                if (page) {
                    url += `?page=${page}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (search) {
                    url += `&search=${search}`;
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
            transformResponse: (res) => ({
                data: res.data?.data,
                total_length: res.data.total
            }),
        }),
        getAllUpload: builder.query({
            query: ({ page, limit, search , status_filter }) => {
                let url = `view-recent-uploads`;

                if (page) {
                    url += `?page=${page}`;
                }
                if (limit) {
                    url += `&limit=${limit}`;
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if (status_filter) {
                    url += `&status_filter=${status_filter}`;
                }
                return {
                    url: url,
                    method: "GET",
                };
            },
            transformResponse: (res) => ({
                data: res.data?.recent_files,
                total_length: res.data?.meta?.total_count
            }),
        })
    }),
});

export const {
    useGetAllCategoriesQuery,
    useAddCategoryMutation,
    useUpdateCategoryMutation,
    useGetCategoriesQuery,
    useDeleteCategoryMutation,
    useGetSuggestionCategoriesQuery,
    useGetAllProjectQuery,
    useGetAllUploadQuery,
} = categoryApi;